import React, { useState } from 'react';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { FileUploader } from 'react-drag-drop-files';
import { wsCreate } from 'services/WService';

const fileTypes = ['JPG'];

function UpdateImageModal(props) {
  const { model, setOpen, showNotify, setProducts, setProduct } = props;
  const [processing, setProcessing] = useState(false);
  const [iteration, setIteration] = useState(1);

  async function handleChange(file) {
    let fd = new FormData();
    fd.append('image', file);

    setProcessing(true);
    let res = await wsCreate(`logi/product/${model.id}/update-sales-image`, fd);

    if (res.success) {
      showNotify(res.message);
      let imagePath = `${res.data.image_sales_path}?v=${iteration}`;
      if (setProducts !== undefined) {
        setProducts((products) => {
          let newProducts = [...products];
          let index = newProducts.findIndex((item) => item.id === model.id);
          if (index !== -1) {
            newProducts[index].image_sales_path = imagePath;
            newProducts[index].image_sales_app = res.data.image_sales_app;
          }
          return newProducts;
        });
      }
      if (setProduct !== undefined) {
        setProduct((product) => {
          return {
            ...product,
            image_sales_path: imagePath,
            image_sales_app: res.data.image_sales_app,
          };
        });
      }
      setOpen({
        ...model,
        image_sales_path: imagePath,
        image_sales_app: res.data.image_sales_app,
      });
      setIteration((iteration) => iteration + 1);
      setProcessing(false);
    } else {
      setProcessing(false);
      showNotify(res.message, 'error');
    }
  }

  return (
    <ModalBase
      model={model}
      setOpen={setOpen}
      hideSave
      maxWidth="sm"
      title={`${model.ItemCode} - ${model.ItemName}`}
    >
      {model.image_sales_path !== null && processing === false && (
        <div
          style={{
            width: '100%',
            maxWidth: '450px',
            minHeight: '200px',
            overflow: 'hidden',
            marginBottom: '20px',
          }}
        >
          <img src={model.image_sales_path} style={{ width: '100%' }} />
        </div>
      )}

      {model.image_sales_path === null && processing === false && (
        <div>
          <p>Solo imagenes jpg, con un peso máximo de 0.5 mb</p>
        </div>
      )}

      {processing && (
        <div style={{ width: '350px', height: '200px', display: 'flex', flexDirection: 'column' }}>
          <div style={{ alignSelf: 'center', width: '60px', height: '60px', marginTop: '45px' }}>
            <div className="lds-dual-ring"></div>
          </div>
        </div>
      )}

      <FileUploader
        handleChange={handleChange}
        name="image"
        types={fileTypes}
        disabled={processing}
        label="Has click o arrastra una imagen aquí"
        hoverTitle="Suelta la imagen aquí"
        maxSize={0.5}
      />
    </ModalBase>
  );
}

export default UpdateImageModal;
